import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { PropType, computed } from 'vue'
import MultiSelectModal, { Option } from '@/components/common/MultiSelectModal.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  modal: Boolean,
  fields: Array as PropType<Option[]>,
  options: Array as PropType<Option[]>,
  stationName: String,
},
  emits: ['update:fields', 'update:modal'],
  setup(__props, { emit }) {

const props = __props

const MAX_SELECT_NUM = 8




const modal = computed({
  get() {
    return props.modal
  },
  set(modal) {
    emit('update:modal', modal)
  },
})

const selected = computed({
  get() {
    return props.fields || []
  },
  set(args) {
    emit('update:fields', args)
  },
})

const emptyMessage = computed(() => {
  return `${props.stationName}に対応する項目が存在しません`
})

return (_ctx: any,_cache: any) => {
  return (__props.options)
    ? (_openBlock(), _createBlock(MultiSelectModal, {
        key: 0,
        modal: _unref(modal),
        "onUpdate:modal": _cache[0] || (_cache[0] = ($event: any) => (_isRef(modal) ? (modal).value = $event : null)),
        selected: _unref(selected),
        "onUpdate:selected": _cache[1] || (_cache[1] = ($event: any) => (_isRef(selected) ? (selected).value = $event : null)),
        options: __props.options,
        maxSelectNum: MAX_SELECT_NUM,
        emptyMessage: _unref(emptyMessage)
      }, null, 8, ["modal", "selected", "options", "emptyMessage"]))
    : _createCommentVNode("", true)
}
}

})